import { getIcon } from '../utils';
import { ArrowRight } from 'lucide-react';

const FALLBACK_DESCRIPTIONS = [
  "Leverage AI to streamline your workflow and get intelligent insights instantly.",
  "Interact with your data using natural language and uncover hidden patterns.",
  "Automate repetitive tasks and boost productivity with smart AI assistance.",
  "Ask questions, explore trends, and make data-driven decisions effortlessly.",
];

export const WorkspaceCard = ({ useCase, onClick, index = 0 }) => {
  const description = useCase.desc || FALLBACK_DESCRIPTIONS[index % FALLBACK_DESCRIPTIONS.length];

  return (
    <button
      onClick={onClick}
      className="w-[200px] flex flex-col items-center text-center p-4 pb-1 rounded-2xl bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 hover:border-[#1d57a5]/40 dark:hover:border-[#4a8ce3]/40 hover:shadow-xl hover:shadow-[#1d57a5]/10 hover:-translate-y-1 transition-all duration-300 group relative overflow-hidden"
    >
      {/* Background gradient accent */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#1d57a5]/5 via-transparent to-[#36a852]/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-2xl" />

      {/* Icon */}
      <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-[#1d57a5] to-[#4a8ce3] flex items-center justify-center mb-3 text-white shadow-md group-hover:scale-110 group-hover:shadow-[#1d57a5]/30 transition-all duration-300">
        {getIcon(useCase.icon)}
      </div>

      {/* Title */}
      <h3 className="text-sm font-bold text-slate-800 dark:text-white mb-1.5 leading-tight group-hover:text-[#1d57a5] dark:group-hover:text-[#4a8ce3] transition-colors">
        {useCase.useCaseName}
      </h3>

      {/* Description */}
      <p className="text-xs text-slate-500 dark:text-slate-400 leading-relaxed flex-1">
        {description}
      </p>

      {/* Footer */}
      <div className="flex items-center gap-1 text-xs font-semibold text-[#1d57a5] dark:text-[#4a8ce3] mt-1 invisible group-hover:visible transition-all duration-300">
        Open workspace <ArrowRight size={12} />
      </div>
    </button>
  );
};
